import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {LoginInfo} from '../../../../projects/api/src/authentication/login-info.model';
import {AuthenticationApiService} from '../../../../projects/api/src/authentication/authentication-api.service';
import {map} from 'rxjs/operators';
import {IsAuthorizedService} from '../services/is-authorized.service';
import {Subject} from 'rxjs';
import {ConfigureService} from '../../../../projects/common/modules/configure/configure.service';
import {ApplicationsApiService} from '../../../../projects/api/src/applications/applications-api.service';

@Injectable()
export class UserStatusResolverService  {
  public defaultScreen$ = new Subject<number>();

  constructor(private authenticationApiService: AuthenticationApiService, private isAuthorizedService: IsAuthorizedService,
              private configService: ConfigureService,
              private applicationsApi: ApplicationsApiService) {
  }

  public changeDefaultScreen(defaultScreen: number) {
    this.defaultScreen$.next(defaultScreen);
  }

  async loadAppConfig(): Promise<void> {
    if (!this.isAuthorizedService.isAuthorized.value) {
      return;
    }
    const data = await this.applicationsApi.getAllWithCache().toPromise();
    const code = this.configService.options.appCode;
    const app = data.find(_app => _app.code === code);
    if (app) {
      try {
        const appConfig = JSON.parse(app.config);
        if (typeof appConfig === 'object') {
          this.configService.options.appConfig = {...this.configService.options.appConfig, ...appConfig};
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<LoginInfo> {
    return this.authenticationApiService.userStatus()
      .pipe(
        map(async (info) => {
            if (info.authenticated) {
              await this.loadAppConfig();
              return info;
            } else {
              this.isAuthorizedService.isAuthorized.next(false);
              setTimeout(() => {
                window.location.href = '#!/login';
              });
              throw new Error('Not authenticated');

            }
          }
        )).toPromise();
  }

}
